import { defineStore } from 'pinia';
export const useGoldPlaySidebar = defineStore('goldplaysidebar', {
    state: () => ({
        isSidebarVisible: false, // The state that controls the visibility of the GoldPlay sidebar
    }),
    actions: {
        toggleSidebar() {
            this.isSidebarVisible = !this.isSidebarVisible;
        },
        openSidebar() {
            this.isSidebarVisible = true;
        },
        handleCloseSidebar() {
            this.isSidebarVisible = false;
        },
    },
});
